import { render, staticRenderFns } from "./AssignmentDocuments.vue?vue&type=template&id=1242e003"
import script from "./AssignmentDocuments.vue?vue&type=script&lang=js"
export * from "./AssignmentDocuments.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDocuments.vue?vue&type=style&index=0&id=1242e003&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports